






import Vue from 'vue';
import Loading from '@/components/Loading.vue';
export default Vue.extend({
  components: {
    Loading,
  },
  data() {
    return {
      content: 'data from App.vue',
      pageLoaded: false,
    };
  },
  mounted() {
    window.addEventListener('load', () => {
      this.pageLoaded = true;
    });
  },
});
